import React from "react";
import { LIMIT_MSG } from "../weight-and-balance-manifest";

export const FuelData = props => {
  const {
    fuel,
    fuelOptions,
    isOneRow,
    dueToMessage = LIMIT_MSG.gw
  } = props;

  const {
    takeOff,
    landing,
    maxFuel,
    minFuel,
    reserveFuel
  } = fuelOptions;

  const minFuelBlock = minFuel && (
    <div className='flex-column'>
      {`Min Fuel: ${fuel.min.percent} % ${fuel.min.lbs} Lbs. ${fuel.min.gal} Gals.`}
    </div>
  );

  const reserveFuelBlock = reserveFuel && (
    <div className={`flex-column ${isOneRow ? "" : "left-padding"}`}>
      {`Fuel at Landing: ${fuel.reserve.percent} % ${fuel.reserve.lbs} Lbs. ${fuel.reserve.gal} Gals.`}
    </div>
  );

  return (
    <div>
      <div className='flex-row'>
        <div className='flex-column flex-2'>
          <b>Fuel: </b>
        </div>

        {takeOff && (
          <div className='flex-column flex-10'>
            <span className='fuel-data'>
              {`Fuel At Take-Off: ${fuel.takeoff.percent} % ${fuel.takeoff.lbs} Lbs. ${fuel.takeoff.gal} Gals.`}
            </span>
          </div>
        )}

        {landing && (
          <div className='flex-column  flex-10'>
            {`Fuel At Landing: ${fuel.landing.percent} % ${fuel.landing.lbs} Lbs. ${fuel.landing.gal} Gals.`}
          </div>
        )}
      </div>

      {maxFuel && (
        <div className='flex-row'>
          <div className='flex-column flex-half'>
            {`Max Fuel w/in C.G. Limits: ${fuel.max.percent} % ${fuel.max.lbs} Lbs. ${fuel.max.gal} Gals. at C.G. value: ${Number(fuel.max.rampWeightArm).toFixed(2)} due to: ${dueToMessage}`}
          </div>
        </div>
      )}

      { isOneRow
        ? <React.Fragment children={[minFuelBlock, reserveFuelBlock]} />
        : <div className='flex-row' children={[minFuelBlock, reserveFuelBlock]} />
      }
    </div>
  )}
